import { render, staticRenderFns } from "./ProductoCombobox.vue?vue&type=template&id=2febba26&scoped=true"
import script from "./ProductoCombobox.vue?vue&type=script&lang=js"
export * from "./ProductoCombobox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2febba26",
  null
  
)

export default component.exports